import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileCheck2 } from "lucide-react";
import { SignedPdfButton } from "@/components/onboarding/SignedPdf";
import { DDBadge } from "@/pages/Onboarding";

// "Signed documents" section on the client drawer.
export function ClientSignedDocs({ clientId, ddStatus }) {
  const [docs, setDocs] = useState(null);
  useEffect(() => {
    api.get(`/clients/${clientId}/signed-documents`).then((r) => setDocs(r.data)).catch(() => setDocs([]));
  }, [clientId]);
  if (!docs) return null;
  return (
    <div className="card-flat p-4 mb-4" data-testid="client-signed-docs">
      <div className="flex items-center justify-between mb-2">
        <div className="overline flex items-center gap-1.5"><FileCheck2 size={12} /> Signed documents</div>
        {ddStatus && <DDBadge s={ddStatus} id="client" />}
      </div>
      {docs.length === 0 ? (
        <div className="text-xs text-[var(--ink-2)]" data-testid="client-signed-docs-empty">No signed engagement documents on file.</div>
      ) : (
        <div className="divide-y divide-[var(--line)]">
          {docs.map((d) => (
            <div key={`${d.onboarding_id}-${d.key}`} className="flex items-center justify-between py-1.5 text-sm">
              <div>
                <div>{d.title}</div>
                <div className="text-[11px] text-[var(--ink-2)]">Signed by {d.signer_name} · {d.signed_at ? new Date(d.signed_at).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" }) : ""}</div>
              </div>
              <SignedPdfButton onboardingId={d.onboarding_id} docKey={d.key} label="Download" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
